export const APPLICATIONS_PREFIX = "@APPLICATIONS/"
export const FETCH_APPLICATIONS = `${APPLICATIONS_PREFIX}FETCH_APPLICATIONS`
export const FETCH_LINKS = `${APPLICATIONS_PREFIX}FETCH_LINKS`
export const FETCH_APPLICATION_LINKS = `${APPLICATIONS_PREFIX}FETCH_APPLICATION_LINKS`
export const FETCH_SECTOR_APPLICATIONS = `${APPLICATIONS_PREFIX}FETCH_SECTOR_APPLICATIONS`
export const FETCH_ASSIGN_END_CONFIG = `${APPLICATIONS_PREFIX}FETCH_ASSIGN_END_CONFIG`
